import { isDepositBlockedCountry } from '@/config/geo-block';
import { useDepositGeoCountry } from '@/lib/api/get-deposit-geo';

export function useIsDepositGeoBlocked() {
  const { data: country, isLoading } = useDepositGeoCountry();

  const isGeoBlocked = isDepositBlockedCountry(country);

  return { isGeoBlocked, country, isLoading };
}
